import React from 'react';
import { TableBody, TableBodyProps } from '@mui/material';
import { ProgressTableRow } from '../ProgressTableRow';

type CustomTableBodyProps = TableBodyProps & {
  noItemsText?: string;
  loading?: boolean;
  bar?: boolean;
};

export const CustomTableBody = (props: CustomTableBodyProps) => {
  const { noItemsText, loading, bar, children, ...rest } = props;

  const childArray = React.Children.toArray(children);

  const progressTableRow = (
    <ProgressTableRow loading={loading} message={noItemsText} bar={bar} />
  );

  return (
    <TableBody {...rest}>
      {childArray.length ? children : progressTableRow}
    </TableBody>
  );
};
